import React from "react";
import Modal from "components/Common/Modal/Minimum";
import Button from "components/Common/Button/Text";
import styles from "./style.scss";

interface Props {
  isOpen: boolean;
  chatTitle: string;
  onClose: () => void;
  onChatDelete: () => void;
}

const DeleteModal: React.FC<Props> = ({
  isOpen,
  chatTitle,
  onClose,
  onChatDelete
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} header="チャット履歴の削除">
      <div className={styles.content}>
        <div className={styles.textWrapper}>
          <p className={styles.title}>{chatTitle}</p>
          <p>このチャット履歴を削除してよろしいですか？</p>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            color="red"
            onClick={() => {
              onChatDelete();
              onClose();
            }}
          >
            削除
          </Button>
          <Button color="navy" onClick={onClose}>
            キャンセル
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
